import { render, staticRenderFns } from "./main-tools.vue?vue&type=template&id=82484062&scoped=true&"
import script from "./main-tools.vue?vue&type=script&lang=js&"
export * from "./main-tools.vue?vue&type=script&lang=js&"
import style0 from "./main-tools.vue?vue&type=style&index=0&id=82484062&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82484062",
  null
  
)

export default component.exports